<template>
  <div id="wtl" :class="cls">
    <h2>{{ this.message(this.$appdata.messages, "wtl").label }}</h2>
    <b-form :action="$appdata.act" method="POST" ref="form">
      <b-row class="mb-3 justify-content-center">
        <b-input
          name="first_name"
          id="first_name"
          v-model="first_name"
          placeholder="First Name"
          @keypress="adv"
          :class="$appdata.input_col_class"
        />
        <div
          class="error"
          v-if="first_name.length >= 1 && $v.first_name.$invalid"
        >
          <p>Please tell us your first name.</p>
        </div>
      </b-row>
      <b-row class="mb-3 justify-content-center">
        <b-input
          name="phone"
          id="phone"
          v-model="phone"
          maxlength="13"
          placeholder="Phone Number"
          @setProp="setProp"
          @keypress="adv"
          @click="clear"
          :class="$appdata.input_col_class"
        />
        <div class="error" v-if="phone_entered && !$v.validPhone">
          <p>Please provide a valid phone number.</p>
        </div>
      </b-row>
      <b-row class="mb-3 justify-content-center">
        <b-input
          name="email"
          id="email"
          type="email"
          v-model="email"
          placeholder="Email Address"
          @keypress="adv"
          :class="$appdata.input_col_class"
        />
        <div class="error" v-if="email.length > 3 && $v.email.$invalid">
          <p>Please provide a valid email address.</p>
        </div>
      </b-row>
      <input type="hidden" name="last_name" value="not provided" readonly />
      <input
        :value="dob"
        type="hidden"
        :id="$appdata.dob_id"
        :name="$appdata.dob_id"
        readonly
      />
      <input
        :value="source_candidate"
        type="hidden"
        :id="$appdata.web_source_id"
        :name="$appdata.web_source_id"
        readonly
      />
      <input
        :id="$appdata.death_benefit_id"
        :name="$appdata.death_benefit_id"
        type="hidden"
        :value="death_benefit"
        readonly
      />
      <input
        :id="$appdata.health_status_id"
        :name="$appdata.health_status_id"
        type="hidden"
        :value="health_bracket_str"
        readonly
      />
      <input
        :id="$appdata.health_issues_id"
        :name="$appdata.health_issues_id"
        type="hidden"
        :value="issues.join(' | ')"
        readonly
      />
      <input
        id="debug"
        name="debug"
        type="hidden"
        :value="$appdata.debug"
        readonly
        v-if="$appdata.debug == 1"
      />
      <input
        id="debug_email"
        name="debug_email"
        type="hidden"
        :value="$appdata.debug_email"
        readonly
        v-if="$appdata.debug == 1"
      />
      <input type="hidden" name="oid" :value="$appdata.oid" readonly />
      <input type="hidden" id="retURL" name="retURL" :value="retURL" readonly />
      <b-row id="button-wrapper" class="mb-3">&nbsp;</b-row>
      <b-button
        :disabled="$v.$invalid"
        class="btn btn-lg btn-primary"
        @click="submitForm"
        size="lg"
        squared
        >{{ this.$appdata.buttons.wtl }}</b-button
      >
    </b-form>
  </div>
</template>
<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import { gdStrings } from "@/mixins/gdStrings";
import { compStyles } from "@/mixins/compStyles";
import { messaging } from "@/mixins/messaging";
export default {
  mixins: [gdStrings, compStyles, messaging],
  props: [
    "active_key",
    "age",
    "dob",
    "death_benefit",
    "health_bracket",
    "health_bracket_str",
    "issues",
    "is_candidate",
  ],
  data() {
    return {
      disp_key: 5,
      cls: "component out",
      first_name: "",
      last_name: "Not provided",
      phone: "",
      email: "",
    };
  },
  validations: {
    first_name: {
      required,
      minLength: minLength(1),
    },
    email: {
      required,
      email,
    },
    validPhone() {
      // Test valid US phone number format.
      if (/^\(\d{3}\)\d{3}[-]\d{4}$/.test(this.phone) == false) {
        return false;
      }

      // Look for some bogus patterns that could make it past the test above.
      var tst = [];
      tst.push(/^\(555/.test(this.phone));
      tst.push(/^\(1/.test(this.phone));
      return tst.indexOf(true) == -1 ? true : false;
    },
  },
  methods: {
    setProp: function (v) {
      this[v.prop] = v.value;
    },
    submitForm: function () {
      this.$refs.form.submit();
    },
    adv: function (event) {
      if (event.key == "Enter" && !this.$v.$invalid) {
        this.submitForm();
      }
    },
    clear: function () {
      this.phone = "";
    },
  },
  computed: {
    phone_entered: function () {
      if (
        !this.$v.email.$invalid &&
        !this.$v.first_name.$invalid &&
        this.phone.length != 0
      ) {
        this.newFormatPhone();
        return true;
      }

      return false;
    },
    retURL: function () {
      if (this.is_candidate === true) {
        return this.$appdata.retURL;
      } else {
        return this.$appdata.retNot;
      }
    },
    source_candidate: function () {
      if (this.is_candidate === true) {
        return this.$appdata.web_source + " - Qual";
      } else {
        return this.$appdata.web_source + " - No Qual";
      }
    },
  },
  watch: {
    active_key: function (n) {
      this.toggleActive(n);
    },
    first_name: function () {
      this.$emit("setProp", { prop: "first_name", value: this.first_name });
    },
    phone: function () {
      this.newFormatPhone();
      this.$emit("setProp", { prop: "phone", value: this.phone });
    },
    email: function () {
      this.$emit("setProp", { prop: "email", value: this.email });
    },
  },
  mounted() {
    this.newFormatPhone();
  },
};
</script>
